<template>
  <div class="vacancies-tab" v-if="titleMetaData">
    <component :is="`style`">
      .vacancy-stages { height: calc(100vh - {{ headerHeight }}px); }
    </component>
    <div class="header" ref="header">
      <div class="header__buttons--top">
        <Button
          hasLeftIcon
          buttonColor="white"
          srcColor="grey"
          :iconSrc="titleIconScr"
          :buttonText="titleButtonText"
          :iconColor="titleIconColor"
          class="header__button"
          buttonSize="big"
          @click="closePanel"
        />
        <p class="header-title__text header__text">{{ titleButtonText }}</p>
      </div>
    </div>
    <StageList v-if="stages.length" :stageList="stages" />
    <div class="body">
      <Alert
        v-if="!stages.length && !loading"
        class="empty"
        text="Нет плана согласования"
      />
    </div>
  </div>
</template>

<script>
import { store } from '@/store';
import Vacancies from 'Elements/Sidebar/Vacancies';
import VacancySteps from 'Elements/Sidebar/VacancySteps';
import Button from 'Elements/Button/Button';
import FormButtons from 'Elements/Form/FormButtons';
import VacancyStages from 'Elements/Sidebar/VacancyStages';
import Subpanel from 'Elements/Subpanel/Subpanel';
import Picture from 'Elements/Picture/Picture';
import Alert from 'Elements/Alert/Alert';
import StageList from 'Elements/Tab/Details/StageList';
import { EVENTBUS_EVENTS } from '@/utils/constants';
import { eventBus } from '@/bus';
export default {
  created() {
    eventBus.$on(EVENTBUS_EVENTS.UPDATE_PLAN, this.updatePanel);

    if (
      localStorage.getItem('rightPanelMode') &&
      !store.state.rightPanel.metadata &&
      !store.state.rightPanel.loading
    ) {
      store.dispatch('rightPanel/getMetadata', {
        intentOrRequest: {
          url: '/index.php?module=HRPAC_COORDINATION&action=getCoordinationPlan',
          request_params: {
            record: this.$route.params.id
          }
        },
        newCheck: false
      });
    }
  },
  data() {
    return {
      currentVacancyId: '',
      headerHeight: 0
    };
  },
  beforeDestroy() {
    eventBus.$off(EVENTBUS_EVENTS.UPDATE_PLAN, this.updatePanel);
  },
  computed: {
    updateIntent() {
      return store.state.rightPanel.updateIntent || {};
    },
    stages() {
      return store.state.rightPanel.metadata?.content?.data?.stages || [];
    },
    titleIconScr() {
      return store.state.rightPanel.metadata?.title?.main[0]?.icon || '';
    },
    titleIconColor() {
      return store.state.rightPanel.metadata?.title?.main[0]?.color || '';
    },
    titleButtonText() {
      return store.state.rightPanel.metadata?.title?.main[0]?.lbl.value || '';
    },
    titleMetaData() {
      return store.state.rightPanel.metadata?.title || null;
    },
    mode() {
      return store.state.rightPanel.panelMode || '';
    },
    loading() {
      return store.state.rightPanel.loading;
    }
  },
  methods: {
    updatePanel() {
      store.dispatch('rightPanel/getMetadata', {
        intentOrRequest: this.updateIntent,
        newCheck: false
      });
    },
    closePanel() {
      store.commit('rightPanel/setParam', {
        name: 'panelMode',
        val: null
      });
    }
  },
  components: {
    StageList,
    Alert,
    Vacancies,
    VacancySteps,
    Button,
    FormButtons,
    VacancyStages,
    Subpanel,
    Picture
  }
};
</script>
<style lang="scss" scoped>
.header {
  border-bottom: 1px solid $grey8;

  &__subpanels {
    & ::v-deep .el-tabs {
      min-height: 50px;
      margin-bottom: 19px;
      padding: 0 18px 0 24px;
    }
  }

  &__buttons {
    &--top {
      display: flex;
      padding: 19px 32px 19px 8px;
      width: 100%;
      justify-content: space-between;
    }

    &--bottom {
      display: flex;
      width: fit-content;
      gap: 8px;
      margin: -3px 0 28px 24px;
    }
  }

  &__button {
    box-shadow: none !important;

    &:hover {
      background: $white;
      outline: none !important;
    }
  }

  &__secondary {
    display: flex;
    gap: 4px;
    align-items: center;
  }

  &__image {
    filter: invert(57%) sepia(10%) saturate(567%) hue-rotate(169deg)
      brightness(90%) contrast(85%);
  }

  &__text {
    font-family: Roboto Medium;
    font-size: 16px;
    line-height: 24px;
    color: $grey64;
  }

  @media (min-width: 1313px) {
    &__button {
      display: none;
    }
  }

  @media (max-width: 1312px) {
    &-title__text {
      display: none;
    }
  }

  &-title__text {
    line-height: 40px !important;
    margin-left: 16px;
  }
}

.body {
  overflow-y: auto;
  max-height: calc(100% - 78px);
  padding: 16px;
}
</style>
